import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let Mark = class Mark extends Vue {
  get style() {
    return {
      width: this.width ? this.width : '100%'
    };
  }
};
Mark.componentName = 'Mark';
__decorate([Prop(String)], Mark.prototype, "width", void 0);
Mark = __decorate([Component({
  name: 'Mark'
})], Mark);
export default Mark;